import api from '@/services/api'

export const getDashboards = async () => {
    try {
        const resp = await api.get('/metabase-dashboard/get-dashboards')
        return resp.data.data
    } catch (e) {
        console.log(e)
    }
}
